import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SharedService } from "../../services/shared.service";
import { ApiService } from "../../services/api.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  public subscribeForm: FormGroup;
  public isSubmitted = false;
  public isError = false;
  public errorMsg = "";
  public isRaMenuOpen = false;
  public isPmsMenuOpen = false;
  @ViewChild("raMenu") raMenuRef: ElementRef | undefined;
  @ViewChild("pmsMenu") pmsMenuRef: ElementRef | undefined;
  constructor(
    public formBuilder: FormBuilder,
    private _shared: SharedService,
    private _api: ApiService,
    private _toast: ToastrService
  ) {}

  ngOnInit() {
    this.subscribeForm = this.formBuilder.group({
      email: ["", [Validators.email, Validators.required]]
    });
  }
  get formControls() {
    return this.subscribeForm.controls;
  }

  subscribe() {
    this._shared.toggleBenefits();
  }

  toggleRaMenu(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.isRaMenuOpen = !this.isRaMenuOpen;
    this.isPmsMenuOpen = false;
  }

  closeRaMenu(): void {
    this.isRaMenuOpen = false;
  }

  togglePmsMenu(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.isPmsMenuOpen = !this.isPmsMenuOpen;
    this.isRaMenuOpen = false;
  }

  closePmsMenu(): void {
    this.isPmsMenuOpen = false;
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event): void {
    if (
      this.isRaMenuOpen &&
      this.raMenuRef &&
      !this.raMenuRef.nativeElement.contains(event.target)
    ) {
      this.isRaMenuOpen = false;
    }
    if (
      this.isPmsMenuOpen &&
      this.pmsMenuRef &&
      !this.pmsMenuRef.nativeElement.contains(event.target)
    ) {
      this.isPmsMenuOpen = false;
    }
  }

  subscribeToNewsletter() {
    console.log(
      this.formControls,
      this.subscribeForm.invalid,
      this.subscribeForm.value
    );
    this.isSubmitted = true;
    if (this.subscribeForm.invalid) {
      return;
    }
    this._api.subscribeNewsletter(this.subscribeForm.value).subscribe(res => {
      console.log("result", res);
      this.isSubmitted = false;
      this.subscribeForm.reset();
      if (res.status === "Success") {
        this._toast.success(res.message);
      } else {
        this._toast.error(res.message);
      }
    });
  }
}
